import { FC } from 'react'
import { EnergyTypeIconProps as Props } from './types'
import { Leaf, Sun, Water, Wind } from '../icons/Icons'
import { EnergyType } from 'types/producer'
import styles from './EnergyTypeIcon.module.scss'
import overviewStyles from 'features/producers-overview/ProducersOverview.module.scss'
import markerStyles from 'components/producers/producer-map/ProducerMarker.module.scss'

const EnergyTypeIcon: FC<Props> = ({ energyType, forFilter, forMarker }) => {
  /**
   * Returns the correct classname for the icon
   *
   * @returns string
   */
  const getClassName = (): string => {
    if (forFilter) return overviewStyles.icon

    if (forMarker) return markerStyles.icon

    return styles.icon
  }

  switch (energyType) {
    case EnergyType.ZON:
      return (
        <div className={getClassName()}>
          <Sun />
        </div>
      )

    case EnergyType.WATER:
      return (
        <div className={getClassName()}>
          <Water />
        </div>
      )

    case EnergyType.WIND:
      return (
        <div className={getClassName()}>
          <Wind />
        </div>
      )

    case EnergyType.BIO:
      return (
        <div className={getClassName()}>
          <Leaf />
        </div>
      )

    default:
      return (
        <div className={getClassName()}>
          <Wind />
        </div>
      )
  }
}

EnergyTypeIcon.defaultProps = {
  forFilter: false,
  forMarker: false
}

export default EnergyTypeIcon
